import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  height: 100%;
  width: 100%;
`;

const Tick = () => (
  <Wrapper
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    viewBox="0 0 468.293 468.293"
    style={{ enableBackground: 'new 0 0 468.293 468.293' } as React.CSSProperties}
    xmlSpace="preserve"
  >
    <circle
      style={{ fill: 'var(--theme-primary)' }}
      cx="234.146" cy="234.146"
      r="234.146"
    />
    <polygon
      style={{ fill: 'white' }}
      points="357.52,110.145 191.995,275.67 110.773,194.451 
              69.534,235.684 191.995,358.148 398.759,151.378 "
    />
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </Wrapper>
)

export default Tick;